import contentTypes from "astrid-distribution/src/constants/contentTypes";

const epubVersions = {
	"EPUB 2.0": {
		contentType: contentTypes.EPUB,
		version: "2.0",
		onix: "101A",
	},
	"EPUB 2.0.1": {
		contentType: contentTypes.EPUB,
		version: "2.0.1",
		onix: "101A",
	},
	"EPUB 3.0": {
		contentType: contentTypes.EPUB,
		version: "3.0",
		onix: "101B",
	},
	"EPUB 3.0.1": {
		contentType: contentTypes.EPUB,
		version: "3.0.1",
		onix: "101C",
	},
	"EPUB 3.1": {
		contentType: contentTypes.EPUB,
		version: "3.1",
		onix: "101D",
	},
	"EPUB 3.2": {
		contentType: contentTypes.EPUB,
		version: "3.2",
		onix: "101E",
	},
	"EPUB 3.3": {
		contentType: contentTypes.EPUB,
		version: "3.3",
		onix: "101F",
	},
	"PDF 1.3": {
		contentType: contentTypes.PDF,
		version: "1.3",
		onix: "107C",
	},
	"PDF 1.4": {
		contentType: contentTypes.PDF,
		version: "1.4",
		onix: "107D",
	},
	"PDF 1.7": {
		contentType: contentTypes.PDF,
		version: "1.7",
		onix: "107G",
	},
	"PDF 2.0": {
		contentType: contentTypes.PDF,
		version: "2.0",
		onix: "107J",
	},
};

export default epubVersions;
